import { jsx as _jsx } from "react/jsx-runtime";
import { SlidersHorizontal } from 'lucide-react';
import { createModulePerms } from '@wit-support/ui-domain';
import { SettingsPage } from './routes/settings.js';
const { Provider: SettingsModulePermsProvider, usePerms: useSettingsPerms } = createModulePerms({
    canReadToggles: false,
    canManageToggles: false,
    canReadBilling: false,
    canManageBilling: false,
    canManageRisk: false,
    canManageNotifications: false,
});
export { SettingsModulePermsProvider, useSettingsPerms };
function SettingsRoute() {
    return _jsx(SettingsPage, { ...useSettingsPerms() });
}
/**
 * Единый раздел настроек системы.
 *
 * Право на вход — самое мягкое из собранных на экране (`settings.read`,
 * member+), и это сознательно: страница — рамка, каждая карточка тянет свои
 * данные своим правом и словами объясняет отказ. Строже был бы разъезд «право
 * на настройку есть, а страницы, где её менять, нет».
 *
 * Один экран, без `sections`: разбивать пять карточек на вкладки значило бы
 * повторить ту же ошибку, ради исправления которой раздел и заведён.
 */
export const settingsModule = {
    id: 'settings',
    label: 'Настройки',
    icon: SlidersHorizontal,
    permission: 'settings.read',
    workspace: 'system',
    // Последним в пространстве «Система»: настройки открывают редко и осознанно,
    // а не в ежедневной работе.
    order: 100,
    description: 'Общесистемные переключатели: инбокс, автоматика, LLM, риски и уведомления.',
    routes: [{ path: '/', component: SettingsRoute }],
};
export { SettingsPage } from './routes/settings.js';
export { setSettingsApiBaseUrl, getLlmSettings, updateLlmSettings, getBillingSettings, updateBillingSettings, getSystemSettings, updateSystemSettings, } from './api.js';
//# sourceMappingURL=index.js.map